import React from 'react'
import Wave from 'react-wavify'
import './Style/ocean.css'
import beach from './Graphics/beach.png'
import { useState, useEffect } from "react";

import SaC from './SignandChest.js'
import OceanSaC from './OceanSignandChest.js'




const Background = ({setVis, curVis}) => {
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  const [beachWidth,setBeachWidth] = useState(100);


  //The beach's height is done in css now (.beachRaise in ocean.css), this only
  //widens the image so it doesn't turn into a sliver on a narrow screen
  function alterBeachWidth(){
  //this default height is guessed when the beach is at a wide size
  let defaultWidth = 1250;
  //the width that looks good is about 1250 pixels which gives it a height of about 120 pixels

  setBeachWidth(Math.max(((defaultWidth-window.innerWidth)/10+100),100));
}

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

   //Runs on mount as well as on resize, so it covers the initial sizing too
   useEffect(() => {
    alterBeachWidth();
  }, [windowWidth]);

  //On mobile the beach is too narrow for four chests, so the first two float
  //out in the ocean instead. Matches the 768px breakpoint used in the css.
  const isMobile = windowWidth <= 768;

  return (


    <div className="ocean">
      {window.innerWidth<768 ?<Wave fill='#2095dd'
        paused={false}
        style={{ display: 'flex', position: 'absolute',
           bottom:0, width: '100%', height: '95%',zIndex:50, opacity:1,pointerEvents:"none",
          }}
          //  Couldn't get the style to work by wra pper
          //So I'm forced to add it this way
        options={{
          height: 20,
          amplitude: 10,
          speed: 0.15,
          points: 3
        }}
  /> :<Wave fill='#2095dd'
        paused={false}
        style={{ display: 'flex', position: 'absolute',
           bottom:0, width: '100%', height: '95%',zIndex:50, opacity:1,pointerEvents:"none",
          }}
          //  Couldn't get the style to work by wra pper
          //So I'm forced to add it this way
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3
        }}
  /> }
      
  <Wave fill='#2095dd'
        paused={false}
        style={{ display: 'flex', position: 'absolute',
           bottom:0, width: '100%', height: '95%',zIndex:70, opacity:0.1,pointerEvents:"none", }}
          //  Couldn't get the style to work by wra pper
          //So I'm forced to add it this way
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3
        }}
  />
    {isMobile &&
      <div className="oceanAlign">
        <OceanSaC title={"About Me"} rotation={6} setVis={setVis} visIndex={0} curVis={curVis} preset={0} />
        <OceanSaC title={"Projects"} setVis={setVis} visIndex={1} curVis={curVis} preset={2} />
      </div>
    }
    <div className='beach'>

      <div className="beachTop">
      <img src={beach} alt="beach" className="beachImage" style={{ width: `${beachWidth}%`}} />
  <div className="chestsAlign">
            {!isMobile && <SaC title={"About Me"} fSize={1.1} rotation={6} setVis={setVis} visIndex={0} curVis={curVis} />}
            {!isMobile && <SaC title={"Projects"} fSize={1.2} setVis={setVis} visIndex={1} curVis={curVis} />}
            <SaC title={"Experience"}fSize={0.9} topPercent={-15} setVis={setVis} visIndex={2} curVis={curVis} />
            <SaC title={"Links"} rotation={-6} setVis={setVis} visIndex={3} curVis={curVis} />
          </div>
        </div>
      <div className="beachRaise">
      </div>
    </div>
    </div>




    
  )
}

export default Background